import parse from "html-react-parser";
import { DateElementType } from "../helpers/types";

type Props = {
    value: string;
    classes?: string;
    onChange?: (value: string) => void;
    error: string | null;
    col?: string;
    showValidation?: boolean;
}

const DateInput = (props: DateElementType & Props) => {
    const {
        value,
        label,
        type,
        classes,
        name,
        placeholder,
        onChange,
        error,
        col,
        showValidation,
        description
    } = props;

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (onChange) {
            onChange(e.target.value);
        }
    }

    const validationClass = () => {
        if (showValidation === false) return '';

        if (value === null || value === undefined) return '';

        if (error) return 'is-invalid';

        return 'is-valid';
    };

    return (
        <div className={col}>
            <label className="form-label">{label}</label>
            {description && <div className="text-muted small mb-2">{parse(description)}</div>}
            <div className="input-group w-100">
                <input 
                    value={value}
                    type={type}
                    name={name}
                    className={`form-control ${showValidation === false ? '' : error && value ? 'is-invalid' : value ? 'is-valid' : ''} ${classes}`}
                    onChange={handleChange}
                    placeholder={placeholder}
                />
                {validationClass() === 'is-invalid' && error && (
                    <div className="invalid-feedback">{parse(error)}</div>
                )}
            </div>
        </div>
    )   
}

export default DateInput;